export default __webpack_public_path__ + "static/media/blackcoffe.637032d0.png";